import crossFetch from 'cross-fetch';

export default fetch || crossFetch